<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
                <div class="col-lg-12">
                    <card type="secondary" shadow
                          header-classes="bg-white pb-12"
                          body-classes="px-lg-12 py-lg-12"
                          class="border-0">
                        <template>
                            <div class="text-muted text-center mb-3">
                                <!--                                <small>Sign in with</small>-->
                            </div>
                            <div class="btn-wrapper text-center">

                            </div>


                            <div style="margin-bottom: 5px;">
                                <el-link icon="el-icon-menu" type="success" style="font-size: large;margin-right: 5px"
                                         @click="fun_click_top_folder(0,1)">Root
                                </el-link>
                                <el-link icon="el-icon-top" type="success" style="font-size: large;margin-right: 15px"
                                         @click="fun_click_top_folder(0,2)">Back
                                </el-link>
                                <!--                                <p style="font-size: large; display: inline; margin-right: 5px">Current Folder:</p>-->
                                <el-link icon="el-icon-folder" type="success" style="font-size: large;margin-right: 5px"
                                         v-for="(item,index) in list_cwd" :key="item"
                                         @click="fun_click_top_folder(index)">/{{item}}
                                </el-link>

                            </div>

                            <el-input
                                    placeholder="Quick Filter"
                                    prefix-icon="el-icon-search"
                                    v-model="search"
                                    clearable
                                    style="margin-bottom: 5px">
                            </el-input>


                            <el-progress :percentage="int_download_percentage" :color="list_customColors"
                                         :text-inside="true" :show-text="true" :stroke-width="16"
                                         :format="func_download_format"></el-progress>


                            <el-table
                                    empty-text="No data available"
                                    v-loading="listLoading"
                                    :data="file_list_filter(tableData,search)"
                                    stripe
                                    height="600"
                                    ref="multipleTable"
                                    tooltip-effect="dark"
                                    style="width: 100%"
                                    @selection-change="handleSelectionChange"
                                    @cell-click="clickhandle">
                                <el-table-column
                                        type="selection"
                                        width="55">
                                </el-table-column>
                                <el-table-column
                                        width="55">
                                    <template slot-scope="scope">
                                        <svg class="icon" aria-hidden="true">
                                            <!--                                            <use xlink:href="#icon-folder-"></use>-->
                                            <use :xlink:href="icondecide(scope.row)"></use>
                                        </svg>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        sortable
                                        prop="name"
                                        label="File Nmae">
                                    <!--                                    <template slot-scope="scope">{{ scope.row.date }}</template>-->
                                </el-table-column>
                                <el-table-column
                                        sortable
                                        prop="size"
                                        label="Size (KB)">
                                </el-table-column>
                                <!--                                <el-table-column-->
                                <!--                                        sortable-->
                                <!--                                        prop="type"-->
                                <!--                                        label="Type">-->
                                <!--                                </el-table-column>-->
                                <el-table-column
                                        sortable
                                        prop="path"
                                        label="Path"
                                        show-overflow-tooltip>
                                </el-table-column>
                                <el-table-column
                                        width="120"
                                        sortable
                                        label="Operation"
                                        show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <el-button class="u-btn"
                                                   type="primary"
                                                   icon="el-icon-view"
                                                   circle
                                                   @click="previewHandle(scope.$index, scope.row)"></el-button>
                                        <el-button class="u-btn"
                                                   type="success"
                                                   circle
                                                   icon="el-icon-download"
                                                   @click="downloadHandle(scope.$index, scope.row)"></el-button>
                                    </template>
                                </el-table-column>

                            </el-table>
                            <div style="margin-top: 10px">
                                <el-button @click="toggleSelection()" type="success">Batch
                                    Download
                                </el-button>
                                <el-button @click="toggleSelection(true)" type="warning">Cancel Selection</el-button>
                            </div>


                            <!--                            <el-radio-group v-model="direction">-->
                            <!--                                <el-radio label="ltr">从左往右开</el-radio>-->
                            <!--                                <el-radio label="rtl">从右往左开</el-radio>-->
                            <!--                                <el-radio label="ttb">从上往下开</el-radio>-->
                            <!--                                <el-radio label="btt">从下往上开</el-radio>-->
                            <!--                            </el-radio-group>-->

                            <!--                            <el-button @click="flag_drawer = true" type="primary" style="margin-left: 16px;">-->
                            <!--                                点我打开-->
                            <!--                            </el-button>-->

                            <el-drawer
                                    title="File Online Preview"
                                    size="100%"
                                    :visible.sync="flag_drawer"
                                    :direction="string_drawer_direction"
                                    :before-close="func_drawer_handle_close"
                                    @opened="func_opened"
                            >

                                <PDFView
                                        v-if="string_preview_type=='1'"
                                        :src.sync="string_pdf_src"
                                        ref="pdfView"
                                        fileName="order"
                                        :sidebarFeatureVisible="false"
                                        :downloadFeatureVisible="false"
                                        :dropzoneFeatureVisible="false"
                                        :toolbarVisible="false"
                                        scale.sync="string_pdf_scale"
                                >
                                    <template slot="right-toolbox"></template>
                                    <!-- Add more buttons/features on the right side of the toolbar -->
                                    <template slot="left-toolbox"></template>
                                    <!-- Add more buttons/features on the left side of the toolbar -->
                                    <template slot="error"></template> <!-- Change the error message design -->
                                    <template slot="loading"></template> <!-- Change the pdf loader design -->
                                </PDFView>
                                <VueDocPreview v-if="string_preview_type==2" :url="string_office_src"
                                               :type="string_document_type" :language="string_document_language"/>
                                <!--                                <VueDocPreview v-if="string_preview_type=='2'" url="https://www.HKHK.US/file/xl/1.js"-->
                                <!--                                               type="code" language="js"/>-->


                                <div class="demo-image__preview" align="center" v-if="string_preview_type=='3'">
                                    <div style="width: 800px;height: 800px;">
                                        <el-image
                                                align="center"
                                                fit="scale-down"
                                                style="width: 100%; height: 100%;"
                                                :src="list_image_src_list[0]"
                                                :preview-src-list="list_image_src_list">
                                        </el-image>
                                    </div>
                                </div>

                                <div class="demo-image__preview" align="center" v-if="string_preview_type=='4'">
                                    <div style="width: 1024px;height: 768px;">
                                        <d-player ref="player" :options="options"></d-player>
                                    </div>
                                </div>

                            </el-drawer>


                        </template>
                    </card>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    import '@/assets/js/iconfont.js'
    import axios from "axios";
    import {PDFView} from 'vue_pdfjs_viewer';
    import VueDocPreview from 'vue-doc-preview'

    import dPlayer from 'vue-dplayer'
    import 'vue-dplayer/dist/vue-dplayer.css'


    export default {
        components: {
            PDFView,
            VueDocPreview,
            dPlayer
            // pdf,
        },
        computed: {},
        mounted() {

        },
        data() {
            return {
                string_download_speed: "",
                int_download_percentage: 0,
                int_download_last_loaded: 0,
                int_download_last_timestamp: 0,
                list_customColors: [
                    {color: '#f56c6c', percentage: 20},
                    {color: '#e6a23c', percentage: 40},
                    {color: '#5cb87a', percentage: 60},
                    {color: '#1989fa', percentage: 80},
                    {color: '#6f7ad3', percentage: 100}
                ],

                player: null,
                options: {
                    autoplay: true,
                    video: {
                        url: '',
                        volume: '1.0',
                    },
                    contextmenu: [
                        {}
                    ]
                },


                string_office_src: "",
                string_document_type: "",
                string_document_language: "",

                playerOptions: {
                    height: '720',
                    autoplay: true,
                    muted: false,
                    language: 'en',
                    playbackRates: [0.7, 1.0, 1.5, 2.0],
                    sources: [{
                        type: "video/mp4",
                        // mp4
                        src: "",
                        // webm
                        // src: "https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm"
                    }],
                    // poster: "https://surmon-china.github.io/vue-quill-editor/static/images/surmon-1.jpg",
                },

                list_image_src_list: [
                    ""
                ],

                string_pdf_src: "",
                string_pdf_scale: "1.25",

                flag_drawer: false,
                string_drawer_direction: 'ttb',
                //type 1表示pdf,type 2表示office或者code，type 3表示图片，type 4表示音频视频
                string_preview_type: "",

                string_cwd: "",
                list_compress_file: [],
                list_compress_type: [],
                list_cwd: ["1", "2", "3"],
                testtest: [1, 2, 3],
                token: '',
                search: '',
                listLoading: true,
                tableData: [
                    // {
                    //     name: '134567',
                    //     size: '1346',
                    //     path: 'sadgfhsh'
                    // },
                    // {
                    //     name: '2',
                    //     size: '235',
                    //     path: 'saefhsratj'
                    // },
                ],
                multipleSelection: []
            }
        },

        methods: {
            func_download_format(percentage) {
                // console.log("format", percentage)
                return `${this.string_download_speed}  ${percentage}%`;
            },
            async func_axios_download(string_final, string_file_name) {
                this.string_download_speed = "";
                this.int_download_percentage = 0;
                this.int_download_last_loaded = 0;
                this.int_download_last_timestamp = 0;
                axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';//获取文件列表
                await axios.get(string_final, {
                    responseType: 'blob',
                    onDownloadProgress: progressEvent => {

                        this.int_download_percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        // const total = parseFloat(progressEvent.currentTarget.responseHeaders['Content-Length'])
                        // const current = progressEvent.currentTarget.response.length
                        //
                        // let percentCompleted = Math.floor(current / total * 100)
                        // console.log('completed: ', percentCompleted)
                        if (this.int_download_last_loaded === 0) {
                            this.int_download_last_loaded = progressEvent.loaded;
                            this.int_download_last_timestamp = progressEvent.timeStamp;
                        } else {
                            let int_temp= Math.round((progressEvent.loaded - this.int_download_last_loaded) / (progressEvent.timeStamp - this.int_download_last_timestamp) * 1000);
                            if(int_temp<1024 && int_temp>0)
                                this.string_download_speed=int_temp.toString()+" B/S";
                            else if ((int_temp/1024)<1024 && (int_temp/1024)>=1)
                                this.string_download_speed=(int_temp/1024).toFixed(2).toString()+" KB/S";
                            else if ((int_temp/1024/1024)<1024 && (int_temp/1024/1024)>=1)
                                this.string_download_speed=(int_temp/1024/1024).toFixed(2).toString()+" MB/S";
                            else if ((int_temp/1024/1024/1024)<1024 && (int_temp/1024/1024/1024)>=1)
                                this.string_download_speed=(int_temp/1024/1024/1024).toFixed(2).toString()+" GB/S";
                        }
                        // console.log(this.string_download_speed)
                        // console.log(progressEvent)
                    }
                })
                    .then(response => {
                        const blob = new Blob([response.data], {type: 'application'})
                        const link = document.createElement('a');
                        link.href = URL.createObjectURL(blob);
                        link.download = string_file_name;
                        link.click();
                        URL.revokeObjectURL(link.href)
                    }).catch(console.error)
            },
            func_opened() {
                // 创建完成的时候加载视频地址并且播放，调整音量1.0
                if (this.string_preview_type == '4') {
                    this.$refs.player.dp.switchVideo({
                        url: this.options.video.url
                    });
                    this.$refs.player.dp.options.volume = 1.0;
                    this.$refs.player.dp.play();
                }

            },

            func_drawer_handle_close(done) {
                this.$confirm('Close Winodw?', 'Notification:', {
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    type: 'warning'
                })
                    .then(_ => {
                        // 如果当前是视频，需要把视频暂停掉
                        if (this.string_preview_type == '4') {
                            this.$refs.player.dp.pause();
                        }

                        done();
                    })
                    .catch(_ => {
                    });
            },
            fun_click_top_folder(index, param) {
                let temp_link = "";
                if (index === 0) {//param为1则表示返回root目录，2则表示需要back一层目录,index为0表示是控制图标
                    if (param === 1)
                        temp_link = "/" + this.list_cwd[0]
                    else if (param === 2) {
                        for (let i = 0; i < this.list_cwd.length - 1; i++) {
                            temp_link += "/";
                            temp_link += this.list_cwd[i];
                        }
                    }

                    // console.log(this.list_cwd[0])
                    // console.log(this.list_cwd[this.list_cwd.length - 1])

                } else {
                    //temp_link用于保存要跳转的路径地址
                    for (let i = 0; i <= index; i++) {
                        temp_link += "/";
                        temp_link += this.list_cwd[i];
                    }
                }

                this.get_file_list_from_server(temp_link);
            },
            async get_file_list_from_server(param_path = "") {

                this.listLoading = true;//加载进度条
                this.token = this.createCode();//生成token并且保存
                //如果param_path为空则是获取当前的根目录，否则是获取子目录,string_cwd保存当前正在访问的目录
                let string_link = "";
                if (param_path.length === 0) {
                    string_link = this.$route.params.pathMatch;
                    this.string_cwd = "/" + this.$route.params.pathMatch
                } else {
                    string_link = param_path.substring(1);
                    this.string_cwd = param_path;
                }
                //当前路径放到list_cwd中，方便显示上方路径
                this.list_cwd = this.string_cwd.split("/");
                this.list_cwd = this.list_cwd.filter(data => data);
                axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';//获取文件列表
                await axios
                    .post(this.GLOBAL.serverSrc + '/apiv1document/getfilelist/', {
                        link: string_link,
                        token: this.token,
                    })
                    .then(response => {
                        if (response.data.status === true) {
                            // this.tableData=[response.data.filelist];
                            // console.log(response.data.filelist[1])
                            // this.tableData= [response.data.filelist[1]]
                            this.tableData = [];
                            for (var i = 0; i < parseInt(response.data.filelist.length); i++) {
                                this.tableData = this.tableData.concat(response.data.filelist[i])
                                // this.tableData=this.tableData||[response.data.filelist[i]]
                            }

                        }


                    })
                    .catch(error => console.log(error))
                // .finally(() => this.loading = false)
                this.listLoading = false;//加载进度条取消
            },
            getFileType: function (name) {
                let fileType = true;//默认true是图片，false是文件
                let nameSplitLength = name.split('.').length - 1;//分割文件名，取最后一个
                let tmp = name.split('.')[nameSplitLength].toLowerCase();
                if (tmp == 'png' || tmp == 'jpg' || tmp == 'jpeg' || tmp == 'gif' || tmp == 'svg' || tmp == 'bmp') {

                } else {
                    fileType = false;
                }
                return fileType;
            },
            getFileName(str) {
                // debugger;
                str = str.substring(str.lastIndexOf("/") + 1);
                return str;
            },
            downloadIamge(imgsrc, name) {//下载图片地址和图片名
                var image = new Image();
                // 解决跨域 Canvas 污染问题
                image.setAttribute("crossOrigin", "anonymous");
                image.onload = function () {
                    var canvas = document.createElement("canvas");
                    canvas.width = image.width;
                    canvas.height = image.height;
                    var context = canvas.getContext("2d");
                    context.drawImage(image, 0, 0, image.width, image.height);
                    var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
                    var a = document.createElement("a"); // 生成一个a元素
                    var event = new MouseEvent("click"); // 创建一个单击事件
                    a.download = name || "photo"; // 设置图片名称
                    a.href = url; // 将生成的URL设置为a.href属性
                    a.dispatchEvent(event); // 触发a的单击事件
                };
                image.src = imgsrc;
            },
            download(imgurl) {
                // debugger;
                let name = this.getFileName(imgurl);
                if (this.getFileType(name)) {
                    //img
                    this.downloadIamge(imgurl, name);
                } else {
                    //file
                    // window.open(imgurl);
                    // window.open(imgurl, "s", "width= 640, height= 480, left=0, top=0, resizable=yes, toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=no, copyhistory=no").blur();
                    // window.focus();
                    // console.log("imgurl",imgurl)
                    // axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';//获取文件列表
                    // axios.get('../file/xl/2.mp4')
                    //     .then(response => {
                    //         // this.ct_body = response.data;
                    //         console.log("成功")
                    //     })

                    let string_temp = imgurl.split("/");
                    let string_final = "";
                    let string_file_name = string_temp[string_temp.length - 1];

                    if (string_temp[3] === "file") {
                        string_final = "..";
                        for (let i = 3; i < string_temp.length; i++) {
                            string_final += "/" + string_temp[i];
                        }
                    } else if (string_temp[3] === "temp") {
                        string_final = "..";
                        for (let i = 3; i < string_temp.length; i++) {
                            string_final += "/" + string_temp[i];
                        }
                    }
                    // ,headers:{}
                    // 异步调用使得可以进度下载
                    this.func_axios_download(string_final, string_file_name)


                }
            },
            file_list_filter(param, target) {
                //如果是第一次加载那么，服务端的数据还没读入进来，所以这个时候tableData长度是0，直接返回
                if (this.tableData.length === 0)
                    return [];
                //如果长度不为0，则需要把size一列变成string且加上KB,MB,GB等符号
                for (let i = 0; i < this.tableData.length; i++) {
                    if (this.tableData[i].size < 1024)
                        this.tableData[i].size = this.tableData[i].size.toString() + " KB";
                    else if (this.tableData[i].size / 1024 >= 1 && this.tableData[i].size / 1024 < 1024)
                        this.tableData[i].size = (this.tableData[i].size / 1024).toFixed(2).toString() + " MB";
                    else if ((this.tableData[i].size / 1024 / 1024) >= 1)
                        this.tableData[i].size = (this.tableData[i].size / 1024 / 1024).toFixed(2).toString() + " GB";
                }
                //下面这一段是快速过滤内容
                // tableData.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()) || data.size.toLowerCase().includes(search.toLowerCase()) || data.path.toLowerCase().includes(search.toLowerCase()) )
                let returnlist = param.filter(data =>
                    // data.name.toLowerCase().includes(target.toLowerCase())||data.path.toLowerCase().includes(target.toLowerCase())||data.size.toString().toLowerCase().includes(target.toLowerCase())
                    data.name.toLowerCase().includes(target.toLowerCase()) || data.path.toLowerCase().includes(target.toLowerCase()) || data.size.toString().toLowerCase().includes(target.toLowerCase())
                )
                return returnlist
            },
            icondecide(row) {
                // console.log(row.type);
                switch (row.type) {
                    case "":
                        return "#icon-file_unknown";
                    case "folder":
                        return "#icon-folder-";
                    case ".docx":
                    case ".doc":
                        return "#icon-DOC";
                    case ".xlsx":
                    case ".xls":
                        return "#icon-XLS";
                    case ".pptx":
                    case ".ppt":
                        return "#icon-PPT";
                    case ".sql":
                        return "#icon-SQL";
                    case ".html":
                    case ".htm":
                        return "#icon-HTML1";
                    case ".js":
                        return "#icon-JS";
                    case ".json":
                        return "#icon-JSON";
                    case ".css":
                    case ".scss":
                    case ".less":
                        return "#icon-CSS";
                    case ".ttf":
                        return "#icon-TTF";
                    case ".psd":
                        return "#icon-PSD";
                    case ".pdf":
                        return "#icon-file_pdf";
                    case ".swf":
                    case ".flv":
                        return "#icon-FLV";
                    case ".iso":
                        return "#icon-ISO";
                    case ".mp3":
                        return "#icon-MP";
                    case ".aac":
                        return "#icon-AAC";
                    case ".ogg":
                    case ".wav":
                    case ".flac":
                    case ".ape":
                        return "#icon-file_music";
                    case ".mov":
                        return "#icon-MOV";
                    case ".avi":
                        return "#icon-AVI";
                    case ".3gp":
                    case ".mkv":
                    case ".ts":
                    case ".f4v":
                    case ".rmvb":
                    case ".rm":
                    case ".mp4":
                        return "#icon-file_video";
                    case ".txt":
                        return "#icon-TXT";
                    case ".dll":
                        return "#icon-File";
                    case ".csv":
                        return "#icon-CSV";
                    case ".com":
                    case ".exe":
                        return "#icon-file_exe";
                    case ".dmg":
                        return "#icon-file_dmg";
                    case ".rar":
                    case ".7z":
                    case ".zipx":
                    case ".zip":
                    case ".tar":
                    case ".gz":
                    case ".tar.gz":
                    case ".tar.xz":
                        return "#icon-file_zip";
                    case ".jpg":
                    case ".jpeg":
                    case ".bmp":
                    case ".png":
                    case ".gif":
                    case ".svg":
                        return "#icon-file_pic";
                    case ".py":
                    case ".java":
                    case ".cpp":
                    case ".c":
                    case ".go":
                    case ".m":
                    case ".csharp":
                    case ".e":
                    case ".sh":
                    case ".bash":
                    case ".ini":
                    case ".nginx":
                    case ".php":
                    case ".cmd":
                    case ".bat":
                    case ".powershell":
                    case ".shell":
                    case ".yaml":
                    case ".xml":
                    case ".typescript":
                        return "#icon-file_code";
                    case ".chm":
                        return "#icon-file_chm";
                    case ".md":
                        return "#icon-file_txt";
                }
                return "#icon-file_unknown"
            },
            createCode() {//这个函数使用来生成token的，这样一次页面只能有唯一的token，从而保证所有上传都到一个文件夹中
                var code = '';
                //设置长度，这里看需求，我这里设置了4
                var codeLength = 50;
                //设置随机字符
                var random = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9);
                //循环codeLength 我设置的4就是循环4次
                for (var i = 0; i < codeLength; i++) {
                    //设置随机数范围,这设置为0 ~ 36
                    var index = Math.floor(Math.random() * 9);
                    //字符串拼接 将每次随机的字符 进行拼接
                    code += random[index];
                }
                //将拼接好的字符串赋值给展示的code
                // this.code = code;
                return code
            },
            previewHandle(index, row) {
                // console.log(index, row.path);
                //如果preview的是文件夹则查询子目录文件夹
                if (row.type === "folder")
                    this.get_file_list_from_server(row.path);
                else {
                    switch (row.type) {
                        case ".pdf":
                            this.string_preview_type = '1';
                            this.string_pdf_src = this.GLOBAL.serverSrc + "/file" + row.path;
                            this.flag_drawer = true;
                            break;
                        case ".docx":
                        case ".doc":
                        case ".xlsx":
                        case ".xls":
                        case ".pptx":
                        case ".ppt":
                            this.string_preview_type = '2';
                            this.string_office_src = this.GLOBAL.serverSrc + "/file" + row.path;
                            this.string_document_type = "office";
                            this.string_document_language = "";
                            this.flag_drawer = true;
                            break;
                        case ".md":
                            this.string_preview_type = '2';
                            this.string_office_src = this.GLOBAL.serverSrc + "/file" + row.path;
                            this.string_document_type = "markdown"
                            this.string_document_language = "markdown";
                            this.flag_drawer = true;
                            break;
                        case ".go":
                        case ".html":
                        case ".htm":
                        case ".txt":
                            this.string_preview_type = '2';
                            this.string_office_src = this.GLOBAL.serverSrc + "/file" + row.path;
                            this.string_document_type = "code"
                            this.string_document_language = "";
                            this.flag_drawer = true;
                            break;
                        case ".js":
                            this.string_preview_type = '2';
                            this.string_office_src = this.GLOBAL.serverSrc + "/file" + row.path;
                            this.string_document_type = "code"
                            this.string_document_language = "js";
                            this.flag_drawer = true;
                            break;
                        case ".c":
                        case ".cpp":
                            this.string_preview_type = '2';
                            this.string_office_src = this.GLOBAL.serverSrc + "/file" + row.path;
                            this.string_document_type = "code"
                            this.string_document_language = "cpp";
                            this.flag_drawer = true;
                            break;
                        case ".xml":
                            this.string_preview_type = '2';
                            this.string_office_src = this.GLOBAL.serverSrc + "/file" + row.path;
                            this.string_document_type = "code"
                            this.string_document_language = "xml";
                            this.flag_drawer = true;
                            break;
                        case ".bash":
                        case ".sh":
                            this.string_preview_type = '2';
                            this.string_office_src = this.GLOBAL.serverSrc + "/file" + row.path;
                            this.string_document_type = "code"
                            this.string_document_language = "bash";
                            this.flag_drawer = true;
                            break;
                        case ".css":
                            this.string_preview_type = '2';
                            this.string_office_src = this.GLOBAL.serverSrc + "/file" + row.path;
                            this.string_document_type = "code"
                            this.string_document_language = "css";
                            this.flag_drawer = true;
                            break;
                        case ".ini":
                            this.string_preview_type = '2';
                            this.string_office_src = this.GLOBAL.serverSrc + "/file" + row.path;
                            this.string_document_type = "code"
                            this.string_document_language = "ini";
                            this.flag_drawer = true;
                            break;
                        case ".java":
                            this.string_preview_type = '2';
                            this.string_office_src = this.GLOBAL.serverSrc + "/file" + row.path;
                            this.string_document_type = "code"
                            this.string_document_language = "java";
                            this.flag_drawer = true;
                            break;
                        case ".less":
                            this.string_preview_type = '2';
                            this.string_office_src = this.GLOBAL.serverSrc + "/file" + row.path;
                            this.string_document_type = "code"
                            this.string_document_language = "less";
                            this.flag_drawer = true;
                            break;
                        case ".nginx":
                            this.string_preview_type = '2';
                            this.string_office_src = this.GLOBAL.serverSrc + "/file" + row.path;
                            this.string_document_type = "code"
                            this.string_document_language = "nginx";
                            this.flag_drawer = true;
                            break;
                        case ".php":
                            this.string_preview_type = '2';
                            this.string_office_src = this.GLOBAL.serverSrc + "/file" + row.path;
                            this.string_document_type = "code"
                            this.string_document_language = "php";
                            this.flag_drawer = true;
                            break;
                        case ".cmd":
                        case ".bat":
                        case ".powershell":
                            this.string_preview_type = '2';
                            this.string_office_src = this.GLOBAL.serverSrc + "/file" + row.path;
                            this.string_document_type = "code"
                            this.string_document_language = "powershell";
                            this.flag_drawer = true;
                            break;
                        case ".scss":
                            this.string_preview_type = '2';
                            this.string_office_src = this.GLOBAL.serverSrc + "/file" + row.path;
                            this.string_document_type = "code"
                            this.string_document_language = "scss";
                            this.flag_drawer = true;
                            break;
                        case ".shell":
                            this.string_preview_type = '2';
                            this.string_office_src = this.GLOBAL.serverSrc + "/file" + row.path;
                            this.string_document_type = "code"
                            this.string_document_language = "shell";
                            this.flag_drawer = true;
                            break;
                        case ".sql":
                            this.string_preview_type = '2';
                            this.string_office_src = this.GLOBAL.serverSrc + "/file" + row.path;
                            this.string_document_type = "code"
                            this.string_document_language = "sql";
                            this.flag_drawer = true;
                            break;
                        case ".yaml":
                            this.string_preview_type = '2';
                            this.string_office_src = this.GLOBAL.serverSrc + "/file" + row.path;
                            this.string_document_type = "code"
                            this.string_document_language = "yaml";
                            this.flag_drawer = true;
                            break;
                        case ".typescript":
                            this.string_preview_type = '2';
                            this.string_office_src = this.GLOBAL.serverSrc + "/file" + row.path;
                            this.string_document_type = "code"
                            this.string_document_language = "typescript";
                            this.flag_drawer = true;
                            break;
                        case ".py":
                            this.string_preview_type = '2';
                            this.string_office_src = this.GLOBAL.serverSrc + "/file" + row.path;
                            this.string_document_type = "code"
                            this.string_document_language = "python";
                            this.flag_drawer = true;
                            break;
                        case ".json":
                            this.string_preview_type = '2';
                            this.string_office_src = this.GLOBAL.serverSrc + "/file" + row.path;
                            this.string_document_type = "code"
                            this.string_document_language = "json";
                            this.flag_drawer = true;
                            break;
                        case ".jpg":
                        case ".jpeg":
                        case ".bmp":
                        case ".png":
                        case ".gif":
                        case ".svg":
                            this.string_preview_type = '3';
                            this.list_image_src_list[0] = this.GLOBAL.serverSrc + "/file" + row.path;
                            this.flag_drawer = true;
                            break;

                        case ".mp4":
                        case ".mp3":
                        case ".aac":
                        case ".flv":
                        case ".ts":
                            // this.func_switch_video();
                            this.options.video.url = this.GLOBAL.serverSrc + "/file" + row.path;
                            this.string_preview_type = '4';
                            this.flag_drawer = true;
                            break;
                        case ".rar":
                        case ".7z":
                        case ".zipx":
                        case ".zip":
                        case ".tar":
                        case ".gz":
                        case ".tar.gz":
                        case ".tar.xz":
                            console.log("压缩文件", row);
                            this.func_decompress(row);
                            break;
                        default:
                            this.$notify({
                                title: 'Notification',
                                message: 'The preview of this type is not supported.',
                                type: 'error'
                            });
                    }
                }

            },
            async func_decompress(row) {
                this.$notify({
                    title: 'Notification',
                    message: 'Start decompressing.',
                    type: 'info'
                });

                axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';//获取文件列表
                await axios
                    .post(this.GLOBAL.serverSrc + '/apiv1document/decompressfile/', {
                        link: row.path,
                        type: row.type,
                        token: this.token,
                    })
                    .then(response => {
                        this.$notify({
                            title: 'Notification',
                            message: 'Decompressed at the root folder.',
                            type: 'success'
                        });

                    })
                    .catch(error => console.log(error))
                this.get_file_list_from_server();//解压缩了，所以刷新文件列表
            },
            async downloadHandle(index, row) {
                // console.log(index, row)
                //如果不是目录的话直接可以下载，this.download可以自动判断是否是图片，图片的话通过其他方式下载，文件的话直接下载
                if (row.type !== "folder") {
                    this.$notify({
                        title: 'Notification',
                        message: 'Start downloading: ' + row.path,
                        type: 'success'
                    });
                    this.download(this.GLOBAL.serverSrc + "/file" + row.path);
                } else {
                    this.listLoading = true;
                    this.$notify({
                        title: 'Notification',
                        message: 'Start compressing:',
                        type: 'info'
                    });

                    axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';//获取文件列表
                    await axios
                        .post(this.GLOBAL.serverSrc + '/apiv1document/compressfile/', {
                            link: [row.path],
                            type: [row.type],
                            token: this.token,
                        })
                        .then(response => {
                            this.$notify({
                                title: 'Notification',
                                message: 'Compressed. Start downloading.',
                                type: 'success'
                            });
                            // console.log(response.data);
                            this.download(this.GLOBAL.serverSrc + response.data.compressed);

                        })
                        .catch(error => console.log(error))
                    // .finally(() => this.loading = false)
                    this.listLoading = false;
                }

            },
            clickhandle(row) {
                // console.log(row)
            },
            async toggleSelection(param) {
                //如果param为真则是取消所有选择
                if (param === true) {
                    this.$refs.multipleTable.clearSelection();
                    return;
                }
                //没有选择任何文件则返回错误
                if (this.list_compress_type.length === 0) {
                    this.$notify({
                        title: 'Error',
                        message: 'At least choose one file.',
                        type: 'error'
                    });
                    return
                }
                //选择了只有一个文件，且这个文件不是文件夹则直接调用download
                else if (this.list_compress_type.length === 1 && this.list_compress_type[0] !== "folder") {
                    this.$notify({
                        title: 'Notification',
                        message: 'Start downloading: ' + this.list_compress_file[0],
                        type: 'success'
                    });
                    this.download(this.GLOBAL.serverSrc + "/file" + this.list_compress_file[0]);
                    return
                } else {
                    this.listLoading = true;
                    //符合需要压缩的条件，发送post通知服务器文件压缩
                    this.$notify({
                        title: 'Notification',
                        message: 'Start compressing:',
                        type: 'info'
                    });

                    axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';//获取文件列表
                    await axios
                        .post(this.GLOBAL.serverSrc + '/apiv1document/compressfile/', {
                            link: this.list_compress_file,
                            type: this.list_compress_type,
                            token: this.token,
                        })
                        .then(response => {
                            this.$notify({
                                title: 'Notification',
                                message: 'Compressed. Start downloading.',
                                type: 'success'
                            });
                            // console.log(response.data);
                            this.download(this.GLOBAL.serverSrc + response.data.compressed);

                        })
                        .catch(error => console.log(error))
                    // .finally(() => this.loading = false)
                    this.listLoading = false;

                }


            },
            handleSelectionChange(val) {
                //把多选的结果保存起来，有路径和文件类型，文件类型用于筛选是否唯一个选中的是文件不是文件夹，如果是一个纯文件走download
                this.multipleSelection = val;
                this.list_compress_file = [];
                this.list_compress_type = [];
                val.forEach(item => this.list_compress_file = this.list_compress_file.concat([item.path]));
                val.forEach(item => this.list_compress_type = this.list_compress_type.concat([item.type]));
            }
        },
        // beforeMount() {
        //     // console.log(this.$route.params.pathMatch);
        //     this.urlpath = this.$route.params.pathMatch;
        //     if (this.urlpath === "JB") {
        //         window.location = 'https://google.com';//因为在beforemount里所以用原生方式
        //         // throw new Error('this is my customed error');
        //         // this.$route.push("https://zhihu.com")
        //         // console.log(this.$route)
        //         // console.log(this.$router)
        //         // this.$route.replace("http://zhihu.com")
        //         // this.$router.push('http://zhihu.com' )
        //
        //         function sleep(milliseconds) {
        //             const date = Date.now();
        //             let currentDate = null;
        //             do {
        //                 currentDate = Date.now();
        //             } while (currentDate - date < milliseconds);
        //         }
        //
        //         sleep(30000);//延时30秒自己的页面会刷新出来
        //     }
        // },
        created() {
            this.get_file_list_from_server();
        },

    }
</script>
<style type="text/css">
    .icon {
        width: 1em;
        height: 1em;
        vertical-align: -0.15em;
        fill: currentColor;
        overflow: hidden;
    }
</style>
<style lang="less" scoped>
    .u-btn {
        display: none;
    }

    .el-table__body tr:hover {
        .u-btn {
            display: inline;
        }
    }

</style>
<style lang="less">
    .el-drawer.ttb {
        overflow: scroll;
    }

    /*下面三段是让drawer拉出后取消焦点*/
    .el-drawer > header > span:focus {
        outline-color: white;
    }

    .el-drawer > header > button:focus {
        outline-color: white;
    }

    .el-drawer > header > button:hover {
        color: rgb(64, 158, 255);
    }
</style>